import React, { useEffect, useRef, useState } from 'react';

import SSButton from '../SSButton';
import './subscribe.scss';

import SSStackFrame from '../SSStackFrame';
import { getSessionStorage } from '../../utils';
import { DOMAIN, SSSB } from '../../Constants/base';
import { getReq } from '../../utils/api';
import { postLogger } from '../../utils/analytics';
import PopUpContainer from '../PopUpContainer';
import PCInstall from '../PCInstall';
import SSAppStatus from '../SSAppStatus';
import LoadingSpin from '../LoadingSpin';

export default function SubScriptionContainer({ setCurrentStep }) {
  const profiles = getSessionStorage('current-profile');
  const userToken = JSON.parse(localStorage.getItem('ss-auth-sales'));
  const [subscriptions, setSubscriptions] = useState([]);
  const [disableButton, setDisableButton] = useState(false);
  const [activeSubscriptions, setActiveSubscriptions] = useState(0);
  const [activeSubscriptionsPrice, setActiveSubscriptionsPrice] = useState(0);
  const [isTrialMode, setIsTrialMode] = useState(false);
  const [openPCPopup, setOpenPCPopup] = useState(false);
  const [sbActivated, setSbActivated] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const pcPlanRef = useRef(null);
  useEffect(() => {
    getUserPlans();
  }, []);

  useEffect(() => {
    if (subscriptions?.subscriptions?.length) {
      let stackBundle = subscriptions?.subscriptions.filter((item) => item.product.nickName === SSSB);
      if (stackBundle[0].currentPlan === 'TRIAL') setIsTrialMode(true);
      if (stackBundle[0].hasActiveSubscription && stackBundle[0].currentPlan !== 'TRIAL') setSbActivated(true);
    }
  }, [subscriptions]);

  const getUserPlans = async () => {
    setIsLoading(true);
    let url = `${DOMAIN}/v1/stripe/user/subscriptions`;
    let requestHeaders = {
      authorization: `bearer ${userToken?.accessToken ? userToken?.accessToken : userToken}`,
    };
    const response = await getReq({ url, requestHeaders });
    const { code, data } = response;
    let timeoutCode = code.toString();
    timeoutCode = Array.from(timeoutCode)[0];
    if (code === 200) {
      setIsLoading(false);
      setSubscriptions(data);
      setActiveSubscriptions(data.totalActiveSubscriptions);
      setActiveSubscriptionsPrice(data.totalActiveSubscriptionsPrice);
      if (data.subscriptions.length === 0) setDisableButton(true);
    } else if (timeoutCode === '5') {
      let newPayload = {
        ...profiles,
        code,
      };
      postLogger('GET_PLANS', newPayload);
    }
  };

  return (
    <div>
      <div className="sub-container">
        <div className="sub-buy-container">
          <div className="member-count">
            {!isTrialMode ? (
              <h1>
                {activeSubscriptions} <span>Active Subscriptions</span>
              </h1>
            ) : (
              isTrialMode && <h1>Trial Mode</h1>
            )}
          </div>
          {activeSubscriptionsPrice > 0 && (
            <span
              style={{
                fontSize: '18px',
              }}
            >
              ${activeSubscriptionsPrice} / month
            </span>
          )}
          {profiles.roleType === 'OWNER' && !isTrialMode && activeSubscriptions > 0 ? (
            <form
              method="POST"
              action={`${DOMAIN}/v1/stripe/customer-portal`}
              onSubmit={(e) => {
                if (disableButton) e.preventDefault();
                else {
                  setDisableButton(true);
                }
              }}
            >
              <input
                style={{ display: 'none' }}
                name="accessToken"
                id="accessToken"
                defaultValue={userToken?.accessToken ? `${userToken?.accessToken}` : `${userToken}`}
                hidden
              />

              <SSButton type={'filled'} btnText={'MANAGE PAYMENT'} isDisabled={disableButton}></SSButton>
            </form>
          ) : (
            ''
          )}
        </div>
        {isLoading ? (
          <div className="sub-container-loader">
            <LoadingSpin />
          </div>
        ) : subscriptions?.subscriptions?.length > 0 ? (
          <div className="subscriptions">
            {/* <div className="plans-header">
              <h1>stack apps</h1>
              <h1 className="plan-title">plan</h1>
            </div> */}
            <div className="active-subscriptions">
              {subscriptions?.subscriptions.map((plan, index) => {
                return (
                  <SSAppStatus
                    isTrialMode={isTrialMode}
                    key={index}
                    plan={plan}
                    getUserPlans={getUserPlans}
                    setOpenPCPopup={setOpenPCPopup}
                    pcPlanRef={pcPlanRef}
                    sbActivated={sbActivated}
                  />
                );
              })}
            </div>
          </div>
        ) : null}
      </div>
      {openPCPopup && (
        <PopUpContainer>
          <PCInstall
            setOpenPopUp={setOpenPCPopup}
            plan={pcPlanRef.current}
            roleType={'OWNER'}
            isActive={true}
            isSBActivated={true}
          />
        </PopUpContainer>
      )}
    </div>
  );
}
